//配置全局访问接口地址
// 获取当前访问的根域名并构建API地址
function getApiUrl() {
    const hostname = window.location.hostname;
    
    // 本地开发环境处理
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.pages.dev') || hostname.startsWith('192.168.') || hostname.startsWith('10.') || hostname.startsWith('172.')) {
        // 本地开发时可以使用默认的API地址或本地API地址
        // return "https://api.greycharge.com";
        return "https://api.gchg.to";
    }
    
    // 提取根域名
    const parts = hostname.split('.');
    let rootDomain;
    
    // 处理域名：如果是 www.example.com 或 subdomain.example.com，提取 example.com
    if (parts.length >= 2) {
        // 取最后两部分作为根域名（例如：example.com）
        rootDomain = parts.slice(-2).join('.');
    } else {
        // 如果只有一个部分，直接使用
        rootDomain = hostname;
    }
    
    // 构建 api.根域名 的URL
    return `https://api.${rootDomain}`;
}

let commonUrl = getApiUrl();

let baseUrl = {
    commonUrl
}

export default baseUrl